import { styled } from '@mui/material/styles';
import { Dialog, IconButton } from '@mui/material';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

const StyledBoxIcon = styled('div')`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 8px;
  display: grid;
  place-items: center;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid
    ${(props) => (props.hiddenBorder ? 'transparent' : '#1e164e52')};
`;
const StyledDialog = styled(Dialog)`
  min-width: ${(props) => props.width || 'auto'};
  .rc-virtual-list-scrollbar-thumb {
    background: ${COLOR.indigo[64]}!important;
    width: 8px !important;
    transition: all;
    &:hover {
      background: ${COLOR.indigo[80]}!important;
    }
    left: 10px;
  }
  .tips {
    position: relative;
  }
  .checkbox-dictionary {
    .MuiCheckbox-root {
      padding: 9px 0px !important;
    }
  }

  .arrow-tip {
    position: absolute;
    background-color: #ffffff;
    left: 84%;
    width: 30px;
    z-index: 101;
    height: 30px;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  }
  .wrap_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
  }
  .loading-load {
    color: #1e164ea3;
  }

  .msg_error {
    font-size: 14px;
    font-weight: 400;
    margin-top: 4px;
    color: #ff3b30;
  }
  .MuiPaper-root {
    max-width: 640px;
  }
  .list-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    padding: 40px;
    height: 260px;
  }
  .loading_container {
    height: 288px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .items {
    margin-top: 12px;
    .MuiTableCell-root {
      padding: 0px !important;
      margin-left: -3px;
      width: 37px;
    }
  }
  .item {
    display: grid;
    grid-template-columns: auto 1fr 1fr;
    margin-bottom: 8px;
    .mr-16 {
      margin-right: 16px;
    }
    .item_word {
      display: flex;
      align-items: center;
      height: 40px;
      box-sizing: border-box;
      justify-content: space-between;
      border: 1px solid #1e164e52;
      padding: 8px 0px 8px 12px;
      font-weight: 500;
      color: #1c1c1e;
      border-radius: 8px;
      font-size: 14px;
    }
  }
  .dialog-content {
    padding: 0px 16px 16px 16px;
  }
  .actions {
    margin-top: 24px;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    .title_list_dictionary {
      font-size: 16px;
      color: #1e164e;
      margin-right: 8px;
      font-weight: 700;
    }
    .action-checkbox {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .clear-icon {
    margin-right: 8px;
    color: #1e164ea3;
    margin-left: -3px;
    padding-left: 0px;
  }
  .delete-button {
    border-radius: 500px;
    font-size: 12px;
    color: ${COLOR.red};
    background-color: ${COLOR.white};
    border-color: ${COLOR.functionalRed[32]};
    text-transform: none;
    padding: 2px 12px;
    width: 100px;

    :hover {
      background-color: ${TRANSPARENT_COLOR.dark};
    }
  }
  .detect-all-button {
    margin-right: 4px;
    border-radius: 500px;
    font-size: 12px;
    border-color: ${COLOR.indigo[32]};
    color: ${COLOR.darkBlue};
    background-color: ${COLOR.white};
    text-transform: none;
    padding: 2px 12px;

    :hover {
      background-color: ${TRANSPARENT_COLOR.dark};
    }
  }
  .icon {
    color: #1e164ea3;
    font-size: 24px;
  }

  .filter_container {
    margin-top: 24px;
    display: grid;
    align-items: center;
    height: 40px;
    grid-template-columns: 1fr 1fr;
    .title_list_dictionary {
      font-size: 16px;
      color: #1e164e;
      font-weight: 700;
    }
    .filter {
      display: flex;
      justify-content: flex-end;

      .text-field-request {
        width: 239px;
        margin-right: 8px;
        .MuiOutlinedInput-root {
          height: 40px;
        }
        input {
          font-size: 14px !important;
        }
        input::placeholder {
          font-size: 14px !important;
        }
        .search_icon {
          color: #1e164ea3;
        }
        .MuiOutlinedInput-root {
          border-radius: 8px;
        }
      }
    }
  }

  .forms_input {
    margin-bottom: 12px;
  }
  .MuiDialog-paper {
    border-radius: 16px;
  }
  .dialog-title {
    text-align: left;
    display: flex;

    justify-content: space-between;
    color: #1c1c1e;
    height: 64px;
    box-sizing: border-box;
    border-bottom: 1px solid #3c3c4329;
    padding: 16px 24px;
    font-size: 24px;
    font-weight: 500;
  }
  .title_input {
    color: #1c1c1e;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 6px;
  }
  .row_input {
    display: flex;
    height: 40px;
  }
  .input_count {
    padding: 0px 12px;
    border: 1px solid #1e164e52;
    border-radius: 8px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    flex: 1;

    input {
      outline: none;
      border: none;
      padding: 8px 0px;
      flex-basis: 100%;
      font-size: 14px;
      font-family: 'SF Pro', sans-serif;
    }
    input::placeholder {
      color: #1c1c1e3d;
    }
    .count_text {
      font-size: 12px;
      font-weight: 400;
      margin-left: 10px;
      color: #1c1c1e7a;
    }
  }
  .noti_header {
    margin-top: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    background-color: #007aff14;
    .tipicon {
      color: #007aff;
      margin-right: 8px;
      font-size: 16px;
      line-height: 100%;
    }

    .title_tip {
      font-size: 14px;
      letter-spacing: -0.4px;
      font-weight: 400;
      color: #1c1c1e;
      line-height: 16px;
      margin-right: 2px;
    }
    .link_view_tip {
      color: #007aff;
      font-size: 14px;
      cursor: pointer;
      line-height: 16px;
      border-bottom: 1px solid #007aff;
      font-weight: 400;
    }
    .hidden_border {
      border: none;
    }
  }

  .suggestions-container {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-top: 4px;
    margin-bottom: 12px;
  }

  .suggestions-title {
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .list-reading-suggest-btn {
    display: flex;
    gap: 4px 16px;
    flex-wrap: wrap;
  }

  .reading-suggest-btn {
    display: flex;
    padding: 4px 8px;
    align-items: center;
    border-radius: 8px;
    border: 1px solid rgba(60, 60, 67, 0.16);
    background: ${COLOR.charcoal};
    width: max-content;
    text-transform: none;
  }
`;
const StyledButton = styled('div')`
  display: flex;
  justify-content: flex-end;
  .add-word-button {
    padding: 8px 24px;
    border-radius: 8px;
    text-transform: none;
    font-size: 14px;
    color: #1e164e;
    width: 151px;
    height: 40px;
    font-weight: 700;
    cursor: ${(props) => (props.disabledBtn ? 'not-allowed' : 'pointer')};
    &:disabled {
      background-color: #ffd60a;
      pointer-events: all;
    }
    &:active {
      background-color: #ffd60a;
    }
    &:focus {
      background-color: #ffd60a;
    }
    &:hover {
      background-color: #ffe66c;
    }
  }
`;

const StyledInput = styled('div')`
  .input {
    padding-left: 12px;
    border: 1px solid #1e164e52;
    border: ${(props) => props.isError && '1px solid #FF3B30'};
    border-radius: 8px;
    display: flex;
    align-items: center;
    flex: 1;
    margin-right: 8px;
    input {
      outline: none;
      border: none;
      padding: 8px 0px;
      font-size: 14px;
      flex-basis: 100%;
      font-family: 'SF Pro', sans-serif;
    }
    .count_text {
      font-size: 12px;
      font-weight: 400;
      color: #1c1c1e7a;
    }
  }
  .pronunciation {
    margin-right: 0px;
  }
`;

const StyledInputCount = styled('div')`
  .input_count {
    border: ${(props) => props.isError && '1px solid #FF3B30'};
  }
`;
const StyledTips = styled('div')`
  position: ${(props) => props.absolute && 'absolute'};
  top: ${(props) => props.absolute && '14px'};
  left: ${(props) => props.absolute && '14px'};
  width: 500px;
  height: 212px;
  margin: auto;
  background-color: white;
  z-index: 100;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0px 4px 48px 0px #00000029;

  .header-tip {
    display: flex;
    align-items: center;
    height: 24px;
    justify-content: space-between;
    .tip-icon {
      font-size: 20px;
    }
  }
  .prevBtn {
    padding: 8px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    opacity: ${(props) => props.isDisabledPrev && 0.3};
    border: 1px solid #3c3c4329;
    box-shadow: none;
    pointer-events: ${(props) => props.isDisabledPrev && 'none'};
  }
  .nextBtn {
    padding: 8px;
    border-radius: 8px;
    display: flex;
    opacity: ${(props) => props.isDisabledNext && 0.3};
    cursor: pointer;
    justify-content: center;
    box-shadow: none;
    align-items: center;
    border: 1px solid #3c3c4329;
    pointer-events: ${(props) => props.isDisabledNext && 'none'};
  }
  .content-tip {
    margin-top: 16px;

    .title_content_tip {
      color: #000000;
      font-weight: 700;
      font-size: 16px;
      margin-bottom: 12px;
    }
    .title_content_content {
      font-weight: 400;
      font-size: 14px;
      height: 42px;
      line-height: 20px;
      color: #1c1c1ea3;
      #highlight {
        font-weight: 700;
        font-size: 14px;
        color: #1c1c1e;
      }
    }
  }
  .bottom_tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    .btn-actions {
      display: flex;
      align-items: center;
    }
    .link_view_tip {
      color: #007aff;
      font-size: 14px;
      cursor: pointer;
      line-height: 16px;
      font-weight: 400;
    }
  }
  .count-content {
    font-weight: 400;
    font-size: 14px;
    color: #3c3c43a3;
    margin: 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .awesome-tip {
    background: #007aff;
    width: 91px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-weight: 500;
    font-size: 14px;
    .great-tip {
      margin-left: 4px;
    }
  }
`;
const StyledActionConfirm = styled('div')`
  display: flex;
  justify-content: flex-end;
  .btn-delete {
    width: 74px;
    border: 1px solid #1e164e29;
    height: 40px;
    font-size: 14px;
    text-transform: capitalize;
    color: #1e164e;
    margin-right: 8px;
    font-weight: 500;
  }
  .btn-cancel {
    width: 74px;
    font-size: 14px;
    text-transform: capitalize;
    color: #1e164e;
    font-weight: 500;
    height: 40px;
  }
`;

const StyledIconButton = styled(IconButton)`
  width: ${({ width }) => width || 'auto'};
  padding: ${({ padding }) => padding || '0px'};
  height: ${({ height }) => height || '10px'};
  border-radius: ${({ borderRadius }) => borderRadius || '100%'};
  border: 1px solid ${COLOR.light};
  border: ${({ hiddenBorder }) => hiddenBorder && 'none'};
  padding: 18px;
  background: ${({ focus }) => focus && TRANSPARENT_COLOR.dark};

  color: ${({ color }) => (color ? COLOR[color] : COLOR.darkBlue)};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};
  &:hover {
    background: ${({ isDisabled }) =>
      isDisabled ? 'none' : TRANSPARENT_COLOR.dark};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};
    .icon {
      color: ${({ colorHover }) => COLOR[colorHover]};
    }
  }

  .text-action {
    font-size: 14px;
    color: ${COLOR.darkBlue};
    &:hover {
      color: ${COLOR.black};
    }
  }
  cursor: ${({ isDisabled, cursor }) =>
    isDisabled ? 'default' : cursor || 'pointer'};
`;
export {
  StyledButton,
  StyledTips,
  StyledActionConfirm,
  StyledDialog,
  StyledInput,
  StyledInputCount,
  StyledBoxIcon,
  StyledIconButton,
};
